<template>
	<c-chip-group>
		<c-chip v-if="camp.free_schedule" class="c-chip-rainbow" type="fill"> 자율일정 </c-chip>
		<c-chip v-if="!camp.free_schedule && camp.vod" style="background: #21282f" type="fill"> 복습 VOD 제공 </c-chip>
	</c-chip-group>
</template>

<script>
export default {
	name: 'EduCardChipGroup',
	props: {
		camp: {
			type: Object,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.c-chip-rainbow {
	background: linear-gradient(-45deg, #f424e8, #eda400, #03d2a0, #6e00ee);
	background-size: 400% 400%;
	color: white;
	animation: gradient 3s ease infinite;

	@keyframes gradient {
		0% {
			background-position: 0% 50%;
		}
		50% {
			background-position: 100% 50%;
		}
		100% {
			background-position: 0% 50%;
		}
	}
}
.c-chip {
	border: none !important;
	color: white !important;
}
</style>
